export default __webpack_public_path__ + "static/media/rtw-hifi.47a04fe0.jpg";